import React from 'react';

export default function NotFound() {
  return (
    <div key="404" className="not-found">
      <h1>404</h1>
    </div>
  );
}



// WEBPACK FOOTER //
// ./scripts/routes/NotFound.jsx